import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { CATEGORY_OPTIONS } from "@/lib/api";

export const Header = () => {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-zinc-100 bg-white/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 md:px-8">
        <button
          className="md:hidden"
          onClick={() => setMobileOpen(true)}
          data-testid="mobile-menu-btn"
          aria-label="Open menu"
        >
          <Menu size={22} />
        </button>

        <Link to="/" className="flex items-center" data-testid="logo-link">
          <img src="/kk-logo.png" alt="KK Beauty & Fashion" className="h-10 w-auto md:h-12" />
        </Link>

        <nav className="hidden items-center gap-7 md:flex">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `text-xs uppercase tracking-wider transition-colors hover:text-kkaccent ${
                isActive ? "text-kkaccent" : "text-zinc-700"
              }`
            }
            data-testid="nav-home"
          >
            Home
          </NavLink>
          {CATEGORY_OPTIONS.map((c) => (
            <NavLink
              key={c.slug}
              to={`/category/${c.slug}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-wider transition-colors hover:text-kkaccent ${
                  isActive ? "text-kkaccent" : "text-zinc-700"
                }`
              }
              data-testid={`nav-${c.slug}`}
            >
              {c.name}
            </NavLink>
          ))}
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `text-xs uppercase tracking-wider transition-colors hover:text-kkaccent ${
                isActive ? "text-kkaccent" : "text-zinc-700"
              }`
            }
            data-testid="nav-contact"
          >
            Contact
          </NavLink>
        </nav>

        <button
          onClick={() => setOpen(true)}
          className="relative"
          data-testid="cart-open-btn"
          aria-label="Open cart"
        >
          <ShoppingBag size={20} />
          {count > 0 && (
            <span
              className="absolute -right-2 -top-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-zinc-900 px-1 text-[10px] font-medium text-white"
              data-testid="cart-count"
            >
              {count}
            </span>
          )}
        </button>
      </div>

      {mobileOpen && (
        <div className="fixed inset-0 z-50 bg-white md:hidden" data-testid="mobile-menu">
          <div className="flex items-center justify-between border-b px-4 py-4">
            <img src="/kk-logo.png" alt="KK Beauty & Fashion" className="h-9 w-auto" />
            <button onClick={() => setMobileOpen(false)} aria-label="Close menu">
              <X size={22} />
            </button>
          </div>
          <nav className="flex flex-col">
            <Link to="/" onClick={() => setMobileOpen(false)} className="border-b px-4 py-4 text-sm uppercase tracking-wider" data-testid="mobile-nav-home">
              Home
            </Link>
            <Link to="/shop" onClick={() => setMobileOpen(false)} className="border-b px-4 py-4 text-sm uppercase tracking-wider">
              All Products
            </Link>
            {CATEGORY_OPTIONS.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                onClick={() => setMobileOpen(false)}
                className="border-b px-4 py-4 text-sm uppercase tracking-wider"
              >
                {c.name}
              </Link>
            ))}
            <Link to="/contact" onClick={() => setMobileOpen(false)} className="border-b px-4 py-4 text-sm uppercase tracking-wider" data-testid="mobile-nav-contact">
              Contact Us
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};
